import styled from "styled-components";
import { Color, ColorDark, Font, breakpoints } from "@/shared/Constants";

export const SignSelectorContainer = styled.div`
  width: 100%;
  margin: 20px auto 0;
  ${Font.sansRegular};
  color: ${Color.grey};
  ${breakpoints.darkMode} {
    [data-theme="dark"] & {
      color: ${ColorDark.textLight};
    }
  }
  .selection-container {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${Color.greyF5F5F5};
    padding: 60px 20px;
    border-radius: 5px;
    padding: 60px 20px;
    position: relative;
    ${breakpoints.phone} {
      padding: 60px 0 40px;
    }
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        background-color: ${ColorDark.darkGrey};
      }
    }
  }
  .sign-selector-box {
    display: flex;
    justify-content: center;
    align-items: center;
    ${breakpoints.tablet} {
      flex-direction: column;
      gap: 40px;
    }
    ${breakpoints.phone} {
      flex-direction: column;
      gap: 40px;
    }
  }

  .sign-selector-list {
    padding: 0;
    margin: 0 20px;
    font-size: 14px;
    ${breakpoints.phone} {
      margin: 0;
    }
  }

  .sign-selector-list li {
    cursor: pointer;
    list-style-type: disc;
    ${Font.sansLight};
    font-size: 13px;
    line-height: 26px;
    color: ${Color.grey};
    ${breakpoints.phone} {
      line-height: 28px;
    }
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
  }
  .sign-selector-signs {
    display: flex;
    align-items: center;
  }
  .selection-content-container {
    display: flex;
    align-items: center;
    ${breakpoints.tablet} {
      flex-direction: column-reverse;
      gap: 30px;
    }
    ${breakpoints.phone} {
      flex-direction: column-reverse;
      gap: 30px;
    }
  }
  .sign-selector-lists {
    display: flex;
    ${breakpoints.tablet} {
      gap: 40px;
      margin-left: 30px;
    }
    ${breakpoints.phone} {
      gap: 40px;
      margin-left: 30px;
    }
  }
  .sign-container {
    display: flex;
    align-items: center;
    ${breakpoints.tablet} {
      flex-direction: column-reverse;
      flex-wrap: wrap;
      gap: 15px;
    }
    ${breakpoints.phone} {
      flex-direction: column-reverse;
      flex-wrap: wrap;
      gap: 15px;
      position: relative;
    }
  }

  .circle {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    background-color: ${Color.white};
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 12px;
    line-height: 24px;
    ${Font.sansSemiBold}
    color: ${Color.grey};
    overflow: hidden;
    cursor: pointer;
    ${breakpoints.phone} {
      width: 126px;
      height: 126px;
      padding: 20px;
      line-height: 18px;
    }
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
        background-color: ${ColorDark.grey};
      }
    }
    &:hover {
      border: 3px solid ${Color.mainColor};
      color: ${Color.mainColor};
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.mainColor};
          border: 3px solid ${ColorDark.mainColor};
        }
      }
    }
    p {
      ${breakpoints.phone} {
        margin-top: 7px;
      }
    }
  }

  .red-circle {
    border: 3px solid ${Color.mainColor};
    color: ${Color.mainColor};
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${Color.white};
        border: 3px solid ${ColorDark.mainColor};
      }
    }
  }

  .circle img {
    width: 145px;
    height: 145px;
    object-fit: contain;
  }

  .sign-name {
    display: none;
  }

  .plus {
    font-size: 30px;
    margin: 0 15px;
    color: gray;
    svg {
      ${breakpoints.phone} {
        width: 32px !important;
        height: 32px !important;
      }
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          fill: ${ColorDark.textLight};
        }
      }
    }
  }

  .sign-selector-button {
    width: 203px;
    height: 40px;
    border: none;
    border-radius: 50px;
    ${Font.sansSemiBold}
    font-size: 16px;
    line-height: 20px;
    margin-left: 38px;
    ${breakpoints.tablet} {
      margin-left: 0;
    }
    ${breakpoints.phone} {
      font-size: 13px;
      margin-left: 0;
    }
  }

  .active {
    background-color: ${Color.mainColor};
    color: ${Color.white};
    cursor: pointer;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        background-color: ${ColorDark.mainColor};
      }
    }
  }
  .disabled-btn {
    background-color: ${Color.greySeparator};
    color: ${Color.white};
    cursor: not-allowed;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        background-color: ${ColorDark.textLight};
      }
    }
  }

  .sign-selector-reset {
    position: absolute;
    top: 15px;
    right: 15px;
    border: none;
    border-radius: 50%;
    background: ${Color.greySeparator};
    width: 35px;
    height: 35px;
    padding: 0;
    padding-top: 2px;
    cursor: pointer;
    svg {
      fill: ${Color.grey};
    }
    ${breakpoints.phone} {
      width: 30px;
      height: 30px;
    }
    .sign-selector-reset-content {
      position: relative;
      display: inline-block;
      .sign-selector-reset-tooltip {
        visibility: hidden;
        background-color: ${Color.secondaryBlack};
        color: ${Color.white};
        text-align: center;
        padding: 10px 5px;
        border-radius: 6px;
        position: absolute;
        z-index: 1;
        width: 140px;
        bottom: 120%;
        left: 50%;
        transform: translateX(-50%);
        ${breakpoints.phone} {
          display: none;
        }
      }
      .sign-selector-reset-tooltip::after {
        content: " ";
        position: absolute;
        top: 100%; /* At the bottom of the tooltip */
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: ${Color.secondaryBlack} transparent transparent
          transparent;
        ${breakpoints.phone} {
          display: none;
        }
      }
      &:hover .sign-selector-reset-tooltip {
        visibility: visible;
        ${breakpoints.phone} {
          display: none;
        }
      }
    }
  }
`;
